import request from './axios';

/**
 * 提交联系表单
 * @param {Object} data 提交的数据
 * @param {String} data.name 姓名
 * @param {String} data.email 邮箱
 * @param {String} data.phone 电话
 * @param {String} data.subject 主题
 * @param {String} data.message 留言内容
 * @returns {Promise<Object>} 返回提交结果
 */
// 查询菜单详情
export function menuList(data) {
  return request({
    url: '/website/menu/list',  // 添加/api前缀
    method: 'post',
    data
  });
}

// 查询科室
export function departmentList(data) {
  return request({
    url: '/website/department/list',  // 添加/api前缀
    method: 'post',
    data
  });
}